<template>
  <div>
    <el-row>
      <el-col style="width: 350px" align="left">
        <div class="option-label" style="margin-left: 10px; padding-bottom: 5px; padding-top: 10px">Show</div>
        <el-radio-group v-model="plotOrganism" size="small" style="margin-left: 10px">
          <el-tooltip class="item" content="Plot data for the current organism" effect="dark" placement="top" :enterable="false">
            <el-radio-button label="current">Current Organism</el-radio-button>
          </el-tooltip>
          <el-tooltip class="item" content="Compare data for all selected organisms" effect="dark" placement="top" :enterable="false">
            <el-radio-button label="all">All selected Organisms</el-radio-button>
          </el-tooltip>
        </el-radio-group>
      </el-col>
      
      <el-col style="width: 200px" align="left">
        <div class="option-label" style="margin-left: 10px; padding-bottom: 5px; padding-top: 10px">Stack on </div>
        <el-select v-model="plotOptions.stacktype" size="small" style="margin-left: 10px; width: 80%">
          <el-option value="annotation" label="Annotation"></el-option>
          <el-option value="kmer" label="Motif size"></el-option>
        </el-select>
      </el-col>

      <el-col v-if="plotOrganism === 'all'" style="width: 250px" align="left">
          <div class="option-label" style="padding-bottom: 5px; padding-top: 10px">Group by </div>
          <el-switch style="display: block" v-model="plotOptions.groupByKmer" inactive-color="#13ce66"
            active-color="#13ce66" active-text="Motif size" inactive-text="Organism"></el-switch>
        </el-col>

    </el-row>

    <el-row v-if="plotOrganism === 'current'" style="margin-top: 20px">
      <modal-unit-stack-anno-kmer-distribution height="70vh" :series="stackDistributionData[store.species.order.indexOf(store.species.current)]"></modal-unit-stack-anno-kmer-distribution>
    </el-row>

    <el-row :gutter="15" v-if="plotOrganism === 'all'">
      <el-row v-if="!(plotOptions.groupByRepeat)">
        <el-col :span="8" v-for="(organism, index) in store.info" :key="organism.OrgInfo.MSDBID"
          style="margin-top: 30px">
          <modal-unit-stack-anno-kmer-distribution :index="index+1" :series="stackDistributionData[index]"></modal-unit-stack-anno-kmer-distribution>
        </el-col>
      </el-row>

      <el-row :gutter="15" v-if="plotOptions.groupByRepeat" >
        <el-col :span="8" v-for="(repeat, index) in plotOptions.selected" :key="repeat"
          style="margin-top: 30px">
          <div><h3>{{ repeat }}</h3></div>
          <modal-unit-stack-anno-kmer-distribution :index="index+1" :series="stackDistributionData[index]"></modal-unit-stack-anno-kmer-distribution>
        </el-col>
      </el-row>
    </el-row> 
  </div>
</template>

<script>
  import { store } from '../scripts/store.js'
  import ModalUnitStackAnnoKmerDistribution from '../components/ModalUnitStackAnnoKmerDistribution.vue'
  import { repeatsMultiSelectOptions } from '../scripts/repeatsMultiSelectOptions.js'
  import { repeatAnnoDist, kmerAnnoDist } from '../scripts/utils.js'
  import { repeats } from '../scripts/repeats.js'


  export default {
    name: 'ModalStackAnnoDistribution',
    components: {
      ModalUnitStackAnnoKmerDistribution
    },
    data() {
      return {
        store: store,
        plotOrganism: "current",
        repeatsMultiSelectOptions: repeatsMultiSelectOptions,
        plotOptions: {
          stacktype: 'kmer',
          groupByKmer: false,
        }
      }
    },
    computed: {
      stackDistributionData() {
        let parameters = this.plotOptions;
        const stacktype = parameters.stacktype;
        const groupby = parameters.groupByKmer;
        const organisms = this.store.species.order;
        let organismNames = [];
        const info = this.store.info;
        const series = [];

        for (const o of organisms) {
          let data = [];
          const orginfo = info.filter(a => { return a.OrgInfo.MSDBID === o; })[0];
          const plotdata = orginfo.AnnoInfo.RepAnno;
          const freqdata = orginfo.RepInfo.PlotData;
          const kmerAnnoData = kmerAnnoDist(plotdata, freqdata, stacktype);
          
          const repeatsObj = {}
          const kmers = [];
          repeats.forEach(d => {
            repeatsObj[d.kmer] = _.map(d.repeats, 'class'); 
            kmers.push(d.kmer);
          })
          const xLabels = kmerAnnoData.keys;
          
          if (stacktype === 'annotation'){
            data = [];
            const npindex = xLabels.indexOf('Non-Promoter')
            if (npindex > -1) { xLabels.splice(npindex, 1) }
            kmers.forEach(a => {
              let x = kmerAnnoData.data[a];
              if (npindex > -1) { x.splice(npindex) }
              data.push({ name: a, type: 'bar', barWidth: '50%', stack: 'Annotation', data: x})   
            })
          }

          else if ( stacktype === 'kmer' ) {
            data = [];
            console.log(kmerAnnoData)
            const annoKeys = ['Exon', 'Intron', 'Genic', 'Intergenic'];
            annoKeys.forEach(a => {
              let x = kmerAnnoData.data[a];
              // console.log(a, x)
              data.push({ name: a, type: 'bar', barWidth: '50%', stack: 'Annotation', data: x})
            })
            // console.log(data)
          }

          series.push({ 
            data: data, 
            yAxis: { 
              name: 'Percentage',
              nameLocation: 'middle',
              nameGap: 30,
              margin: 8,
              nameTextStyle: {
                fontSize: 14,
                fontWeight: 'bold'
              },
              type: 'value', 
              axisTick: { alignWithLabel: true },
              min: 0, 
              max: 100 
            }, 
            xAxis: {
              type: 'category', 
              data: xLabels, 
              axisLabel: { rotate: 40 } 
            } 
          })
        }
        // console.log(series)
        return series;
      }
    }
  }
</script>